const getPrettyTime = (time: number) => {
    if (time < 0) return '00';
    if (time < 10 || !time) return `0${time}`;
    return time;
};

/**
 *
 * @param time - timestamp in ms
 */
export const getFormatTimeLeft = (time: number) => {
    const timeInSeconds = Math.floor(time / 1000);
    const seconds = getPrettyTime(timeInSeconds % 60);
    const hours = getPrettyTime(Math.floor(timeInSeconds / 3600));
    const minutes = getPrettyTime(Math.floor((timeInSeconds % 3600) / 60));

    return `${hours}:${minutes}:${seconds}`;
};
